/**
 * Created by Administrator on 2018/1/3 0003.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
Vue.use(VueRouter)
let router = new VueRouter({
  routes: routes,
  mode: 'hash'
})
router.beforeEach((to, from, next) => {
  next(true)
})
router.afterEach(route => {

})
export default router



// WEBPACK FOOTER //
// ./src/router/router.js